import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo recibo el ebook?',
  a: 'Recibirás acceso inmediato luego de realizar la compra. Podrás verlo y descargarlo al instante.'
}, {
  q: '¿Qué pasa si no me gusta o no es lo que esperaba?',
  a: 'Tenés una garantía de 7 días. Si sentís que no es para vos, podés solicitar la devolución.'
}, {
  q: '¿Es seguro alimentar a mi perro con comida natural?',
  a: 'Sí, siempre que esté bien balanceada. En este ebook aprenderás exactamente cómo hacerlo sin errores.'
}, {
  q: '¿Necesito experiencia previa en nutrición canina?',
  a: 'No, para nada. El ebook está diseñado para que cualquier dueño pueda seguirlo paso a paso, sin conocimientos previos en nutrición.'
}, {
  q: '¿Funciona para cualquier raza y tamaño de perro?',
  a: 'Sí. Las pautas y recetas del ebook se adaptan a perros de todas las razas y tamaños. Incluye indicaciones para ajustar las porciones según el peso de tu perro.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-10 md:py-12 px-4 bg-lightgreen" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4 font-serif" data-id="element-21">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" data-id="element-22"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-23">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className={`bg-white rounded-xl border ${isOpen ? 'border-primary shadow-md' : 'border-sage shadow-sm'} overflow-hidden transition-all duration-300`} data-id="element-24">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-25">
                  <span className={`font-semibold text-lg pr-4 ${isOpen ? 'text-primary' : 'text-charcoal'}`} data-id="element-26">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-primary' : 'text-gray-400'}`} data-id="element-27" />
                </button>

                <AnimatePresence data-id="element-28">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-29">
                      <div className="px-6 pb-5 text-gray-600 border-t border-gray-50 pt-3" data-id="element-30">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}